module.exports = __webpack_public_path__ + "fonts/badbc25.otf";